<template>
  <base-modal height="600"
              :show="show"
              @close="close" >
    <div slot="header">
      {{ $t("installedDevices.title") }}
    </div>
    <device-list />
  </base-modal>
</template>

<script>
  import DeviceList from '@/components/Common/InstalledDevices/InstalledDevicesList.vue'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      DeviceList
    },

    beforeMount() {
      this.setOpenListener('devices')
    }
  }
</script>
